import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql, Link } from "gatsby"
import {LayoutClean as Layout} from "../components/layout"
import SEO from "../components/seo"
import GridIcons from "../components/content/gridicons"
import Helmet from "react-helmet"

import Subscribe from "../components/subscribe"
import { Menu, MenuCTA } from "../components/content/menu"

const IndexPage = ({ siteTitle, data }) => (
  <StaticQuery
    query={graphql`
      query IndexPageQuery {
        site {
          siteMetadata {
            title
            url
            blogUrl
            appUrl
            getStartedUrl
            twitterUrl
            linkedInUrl
            feedbackUrl
            description
            homeDescription
            homeDescription2
            homeDescription3
            footerDescription
          }
        }
      }
    `}
    render={data => (
      <>
        {/* // Inside your component */}
        <Helmet
          bodyAttributes={
            {
              // class: "home",
            }
          }
        />{" "}
        <Helmet>
          {/* <!-- IE10 viewport hack for Surface/desktop Windows 8 bug --> */}
          {/* <link
            href="/theme/css/ie10-viewport-bug-workaround.css"
            rel="stylesheet"
          /> */}

          {/* <!-- Custom styles for this template --> */}
          {/* <link href="/theme/css/cover.css" rel="stylesheet"/> */}
      
        </Helmet>
        <Layout>
        <SEO title={data.site.siteMetadata.description} />
        <div>
     
          <div className="nav-container">
            <nav>
              <div className="nav-bar">
                <div className="module left">
                  <div className="logo">
                    <span className="wsite-logo">
                      <a href="/">
                        {/*<span id="wsite-title" style="color: black; font-size: 15px;">THE LEAN FOUNDER</span>*/}
                        <img
                          src="img/theleanfounder_logo.png"
                          alt="The Lean Founder"
                          width="50%"
                        />
                      </a>
                    </span>
                  </div>
                  {/*
                  <a href="/">
                      <img class="logo logo-light" alt="Venture Audit" src="/img/logo-light.png">
                      <img class="logo logo-dark" alt="Venture Audit" src="/img/venture-logo-dark2.png">
                  </a>*/}
                </div>
                <div className="module widget-handle mobile-toggle right visible-sm visible-xs">
                  <i className="ti-menu" />
                </div>
              </div>
            </nav>
          </div>
          <div className="main-container">
            <section className="image-edge">
              <div id="imageSwap" className="col-md-6 col-sm-4 p0">
                <img
                  alt="Screenshot"
                  className="mb-xs-24"
                  src="/img/phone4.png"
                />
              </div>
              <div className="container">
                <div className="col-md-5 col-md-offset-1 col-sm-7 col-sm-offset-1 v-align-transform right">
                  <h3 className="uppercase mb40 mb-xs-24">
                    De-risk your business
                  </h3>
                  <p className="lead">
                    Benchmark and prioritize business gaps and risks.{" "}
                  </p>
                  <p>
                    Sign Up for an invitation to our private beta.
                    <br />
                  </p>
                  <form
                    className="halves form-newsletter"
                    data-success="Thanks for your submission, we will be in touch shortly."
                    data-error="Please fill all fields correctly."
                  >
                    <input
                      className="mb16 validate-required validate-email signup-email-field"
                      type="text"
                      placeholder="Email Address"
                      name="email"
                    />
                    <input
                      className="mb16"
                      type="submit"
                      defaultValue="Sign Up"
                    />
                    <span>*We won't share your email with third parties.</span>
                    <iframe
                      srcDoc='<!-- Begin MailChimp Signup Form --><link href="https://cdn-images.mailchimp.com/embedcode/classic-081711.css" rel="stylesheet" type="text/css"><style type="text/css">	#mc_embed_signup{background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif; }	/* Add your own MailChimp form style overrides in your site stylesheet or in this style block.	   We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */</style><div id="mc_embed_signup"><form action="//uvisionlabs.us1.list-manage.com/subscribe/post?u=f218b9e9413789e0700e0dfee&id=2759b3fec2" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>    <div id="mc_embed_signup_scroll">	<h2>Subscribe to our mailing list</h2><div class="indicates-required"><span class="asterisk">*</span> indicates required</div><div class="mc-field-group">	<label for="mce-EMAIL">Email Address  <span class="asterisk">*</span></label>	<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL"></div><div class="mc-field-group">	<label for="mce-FNAME">First Name </label>	<input type="text" value="" name="FNAME" class="" id="mce-FNAME"></div><div class="mc-field-group">	<label for="mce-LNAME">Last Name </label>	<input type="text" value="" name="LNAME" class="" id="mce-LNAME"></div>	<div id="mce-responses" class="clear">		<div class="response" id="mce-error-response" style="display:none"></div>		<div class="response" id="mce-success-response" style="display:none"></div>	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->    <div style="position: absolute; left: -5000px;"><input type="text" name="b_f218b9e9413789e0700e0dfee_2759b3fec2" tabindex="-1" value=""></div>    <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>    </div></form></div><!--End mc_embed_signup-->'
                      className="mail-list-form"
                    />
                  </form>
                </div>
              </div>
            </section>

            <section className="bg-dark">
              <div className="container">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h3 className="uppercase color-primary mb40 mb-xs-24">
                      WHY DE-RISK YOUR BUSINESS?
                    </h3>
                    <br/>
                    <br/>
                    {/* <p className="lead">​IDENTIFY and prioritize risk.</p> */}
                    <h4 className="lead">
                      Are you concerned with risks and gaps while starting,
                      executing or growing your business?
                    </h4>
                    <h5 className="lead">
                      Do you know the right questions to ask when starting,
                      growing or investing in a company?
                    </h5>
                    <br/>
                    <br/>
                    <p className="lead">
                      The Lean Founder™ is a powerful personalized mobile
                      learning application and assessment that helps founders,
                      startups and other organizations with best practices,
                      knowledge, questions &amp; recommendations to evaluate
                      business, team &amp; process risks across a range of
                      functional areas.
                    </p>
                  </div>
                </div>
              </div>
            </section>
     
            <section className="bg-primary text-black">
              <div className="container">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h3 className="uppercase color-primary2 text-black mb40 mb-xs-24" style={{color: 'black !important'}}>
                      ​IDENTIFY AND PRIORITIZE RISK.
                    </h3>
                    <h4 className="lead text-white2 text-black " style={{color: 'black;'}}>
                      Do you know the right questions to ask when building and
                      investing in a company ?
                    </h4>

                    <div className="lead text-white2 text-black paragraph1" style={{color: 'black;'}}>
                      {/* <br/><font size="14">Do you know the right questions to ask when building and investing in a company ?</font> */}
                      {/* <br />
                      <br />
                      <br />
                      <span>
                        The Lean Founder is a powerful new personalized learning
                        application and content that accelerate's founders and
                        teams at companies and organizations with the right
                        questions to ask and tools to benchmark and audit
                        training gaps as well as due diligence, business
                        governance &amp; process risks.
                      </span>
                      <br />
                      <br />
                      <br /> */}
                        <div className="container">
                          <div className="row">
                            <div className="col-sm-12 text-center" style={{color: 'black;'}}>


                            Business Case  
                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center" style={{color: 'black;'}}>
                      
                            MVP          

                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center text-black"  style={{color: 'black;'}}>

              
                            Risk Assessment    
                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center text-black"  style={{color: 'black;'}}>
                    
                            Team      

                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center text-black"  style={{color: 'black;'}}>
                  
                            Co-Founders    

                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>
                    
                            Employees  

                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>

                      
                            ​HR
                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>

                            Product Management

                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>

                            Due Diligence

                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>

                            Technology

                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>


                            Change Management
                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>


                            Project Management
                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>

                            Brand

                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>

                            Marketing

                              </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center"  style={{color: 'black;'}}>

                            Social Media

                              </div>
                          </div>

                        </div>
                              
                     
                        
                    </div>
                  </div>
                </div>
              </div>
            </section>
       <section className="image-square right">
              <div className="col-md-6 image">
                <div className="background-image-holder2">
                  <img
                    alt="image"
                    className="background-image"
                    src="/img/phone7.png"
                  />
                </div>
              </div>
              <div className="col-md-6 content">
                <h3 className>From Startup to Growth.</h3>
                <p className="mb0">
                  The Lean Founder™ platform provides you with a library of
                  resources for training and assessments that you can browse,
                  search and learn about - many of which cover a wide range of
                  relevant risk mitigating topics in today's modern business.
                </p>
              </div>
            </section>
            <section className="image-square left">
              <div className="col-md-6 image">
                <div className="background-image-holder2">
                  <img
                    alt="image"
                    className="background-image"
                    src="/img/phone9.png"
                  />
                </div>
              </div>
              <div className="col-md-6 col-md-offset-1 content">
                <h3>Just Train or Conduct Assessments.</h3>
                <p className="mb0">
                  Brush up, learn from the ground up and even benchmark your
                  company and team.
                </p>
              </div>
            </section>
            <section className="image-square right">
              <div className="col-md-6 image">
                <div className="background-image-holder2">
                  <img
                    alt="image"
                    className="background-image"
                    src="/img/phone8.png"
                  />
                </div>
              </div>
              <div className="col-md-6 content">
                <h3>Validate Assumptions and Feedback.</h3>
                <p className="mb0">
                  Start with a question and end with answers to gain insight
                  into your business but doing this with your team is a lot more
                  accurate.
                </p>
              </div>
            </section>
            <section className="image-square left">
              <div className="col-md-6 image">
                <div className="background-image-holder2">
                  <img
                    alt="image"
                    className="background-image"
                    src="/img/phone6.png"
                  />
                </div>
              </div>
              <div className="col-md-6 col-md-offset-1 content">
                <h3>Evaluate Results and Prioritize Change.</h3>
                <p className="mb0">
                  The Lean Founder™ will help your business and team realize
                  gaps, risks and recommendations from standards and team
                  feedback to help prioritize changes to address gaps and risks.
                </p>
              </div>
            </section>
            <section id="icons" className="bg-dark">
              <div className="container">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h3 className="uppercase color-primary mb40 mb-xs-24">
                      From Startup to Growth.
                    </h3>
                    <p className="lead">
                      The Lean Founder™ provides you with a growing amount of
                      'modules' that you can browse and search and learn about
                      covering a wide range of topics in today's modern
                      business.
                    </p>
                    <br />
                    <br />
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24 mb64">
                      <div className="left">
                        <i className="ti-user icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">You </h5>
                        <p>
                          Understand potential goals and skills you need for
                          success: how to network, how to market yourself, and
                          how to build upon your personal strengths.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24 mb64">
                      <div className="left">
                        <i className="ti-light-bulb icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Idea </h5>
                        <p>
                          Understand risk and gaps in turning ideas into
                          sustainable and successful projects and companies.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24 mb64">
                      <div className="left">
                        <i className="ti-briefcase icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Business Model </h5>
                        <p>
                          Understand various factors relevant to prioritizing
                          risks your Canvases, Relationships, Patterns and
                          business model innovation.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24 mb64">
                      <div className="left">
                        <i className="ti-blackboard icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Team </h5>
                        <p>
                          Define how to structure and build high-functioning
                          teams and grow cultures that support them.
                          <br />
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24">
                      <div className="left">
                        <i className="ti-cup icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Product </h5>
                        <p>
                          Understand how to design and build products and manage
                          consumer expectations and experiences around your
                          products.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24">
                      <div className="left">
                        <i className="ti-palette icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Design</h5>
                        <p>
                          Learn about the crucial role of product design and
                          user experience design in a successful technology
                          companies.
                          <br />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24 mb64">
                      <div className="left">
                        <i className="ti-stats-up icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Growth </h5>
                        <p>Plan for and manage fast and sustainable growth.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24 mb64">
                      <div className="left">
                        <i className="ti-shopping-cart icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Marketing </h5>
                        <p>
                          Improve execution through research-driven and
                          experience-driven marketing to help your product or
                          vision succeed.
                          <br />
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24 mb64">
                      <div className="left">
                        <i className="ti-id-badge icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Sales</h5>
                        <p>
                          Learn how to develop sales practices that work for
                          fast-moving companies.
                          <br />
                          <br />
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24 mb64">
                      <div className="left">
                        <i className="ti-mobile icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Technology </h5>
                        <p>
                          Improve how to define, design, develop and integrate
                          technology projects.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24">
                      <div className="left">
                        <i className="ti-thumb-up icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Customers</h5>
                        <p>
                          Learn about how to effectively conduct customer
                          discovery, development, validation according to lean
                          principles.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24">
                      <div className="left">
                        <i className="ti-money icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Funding</h5>
                        <p>
                          Learn about different types of funding, from angel
                          investors to seed fundraising to crowdsource funding
                          and associated gaps.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24">
                      <div className="left">
                        <i className="ti-settings icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Operations</h5>
                        <p>
                          Asssess your team's ability to start and operate a
                          sustainable business.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24">
                      <div className="left">
                        <i className="ti-panel icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Management</h5>
                        <p>
                          Evaluate gaps related to managing change in a growing
                          business.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="feature feature-3 mb-xs-24">
                      <div className="left">
                        <i className="ti-star icon-sm" />
                      </div>
                      <div className="right">
                        <h5 className="uppercase mb16">Leadership</h5>
                        <p>
                          Learn to how to build leaders in your organization and
                          how to mentor others to grow.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="bg-white">
              <div className="container">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <h2>Built by experts, for your business.</h2>
                    <p className="mb40 mb-xs-24">
                      The Lean Founder™ system is a simple but powerful tool
                      based on years of research working with various sizes of
                      organizations and standards to help leaders make better
                      decisions with their business resources and assess gaps
                      and risks along with benchmarking against standards.
                    </p>
                    <a className="mb0 btn btn-lg btn-filled" href="#top">
                      Sign Up
                    </a>
                  </div>
                </div>
                {/*end of row*/}
              </div>
              {/*end of container*/}
            </section>
            <footer className="footer-2 bg-dark">
              <div className="container">
                <div className="row">
                  <div className="col-sm-8">
                    <span className="fade-half">
                      <a href="privacypolicy.html">Privacy Policy</a> |{" "}
                      <a href="termsofuse.html">Terms of Use</a> - © Copyright
                      2015-2021 The Lean Founder™{" "}
                      <a href="http://theleanfounder.com/">
                        theleanfounder.com
                      </a>
                    </span>
                    {/*  <br/>A product of &nbsp;<a href="http://theleanfounder.com/"><img class="image-xxs fade-half" alt="theleanfounder.com" src="/img/logouvision.png"></a> */}
                  </div>
                  <div className="col-sm-4 text-right">
                    <ul className="list-inline social-list">
                      <li>
                        <a href="http://twitter.com/lean_founder">
                          <i className="ti-twitter-alt" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.facebook.com/The-Lean-Founder-458284434333792/">
                          <i className="ti-facebook" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
        </Layout>
      </>
    )}
  />
)

IndexPage.propTypes = {
  siteTitle: PropTypes.string,
}

IndexPage.defaultProps = {
  siteTitle: ``,
}

export default IndexPage
